import Navbar from "../components/Navbar";
import design from "../Assets/design-0.svg";
import design2 from "../Assets/design-2.svg";
import Image from "../Assets/jioglass-lp-bg.jpg";
import { Link, Redirect, useHistory } from "react-router-dom";

import "./Landingpage.styles.scss";
import { useUser } from "../hooks/useUser";
import Console from "./console/Console";
import ConsoleLocalStorage from "../storage/storage";

const Landingpage = () => {
  const { user } = useUser();
  const history = useHistory();
  if (user && ConsoleLocalStorage.getAccessToken()) {
    if (ConsoleLocalStorage.getOrganization()?.status === 4) {
      ConsoleLocalStorage.setUser({});
      ConsoleLocalStorage.setAccessToken("");
    }
    history.push("/console");
  }
  return (
    <div>
      <Navbar showSignup={true} />
      <div className="container mt-5 landing-page-div">
        <div className="card card1">
          <div className="m-0 row">
            <div
              className="col-lg-6 col-img"
              style={{ backgroundImage: `url(${Image})` }}
            ></div>
            <div className="px-0 text-center col-lg-6 text-col">
              <div className="alltext">
                <h1 className="jio-h1">JioGlass Developer</h1>
                <h1 className="dash-h1">Dashboard</h1>
                <p className="col-p">
                  Build AR and VR Applications for the next billion
                  <br />
                  internet users
                </p>

                <Link to="/login">
                  <button className="btn btn-primary btn-sm md-4 enterBtn">
                    Sign In
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="row row2" style={{ marginBottom: "5rem" }}>
          <div className="mt-5 col-lg-6">
            <div
              className="card card2 text-on-card"
              style={{
                backgroundImage: `url(${design})`,
                backgroundSize: "cover",
              }}
            >
              <h2>Design</h2>
              <p className="logo-text">
                Jio Mixed Reality Design
                <br />
                System
              </p>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://docs.tesseract.in/design/"
              >
                <ExploreButton />
              </a>
            </div>
          </div>
          <div className="mt-5 col-lg-6">
            <div
              className="card card3 text-on-card"
              style={{
                backgroundImage: `url(${design2})`,
                backgroundSize: "cover",
              }}
            >
              <h2>Develop</h2>
              <p className="logo-text">
                Introduction to Jio Mixed
                <br />
                Reality Development
              </p>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://docs.tesseract.in/develop/"
              >
                {" "}
                <ExploreButton />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Footer =================================================================================================== */}
      <footer className="page-footer font-small indigo">
        <div className="container text-center text-md-left">
          <div className="row justify-content-around">
            {/* <hr className="clearfix w-100 d-md-none"></hr> */}
            <div className="col-md-1"></div>
            <div className="col-md-2">
              <p className="mt-3 font-weight-bold FooterLinks">Product</p>
              <ul className="list-unstyled">
                <li>
                  <a
                    href="https://tesseract.in/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    JioGlass
                  </a>
                </li>
              </ul>
              <p className="mt-4 font-weight-bold FooterLinks">Consumer</p>
              <ul className="list-unstyled">
                <li>
                  <a
                    href="https://tesseract.in/consumer"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Consumer Applications
                  </a>
                </li>
              </ul>
              <p className="mt-4 font-weight-bold FooterLinks">Enterprise</p>
              <ul className="list-unstyled">
                <li>
                  <a
                    href="https://tesseract.in/enterprise"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Enterprise Solutions
                  </a>
                </li>
              </ul>
            </div>

            {/* <hr className="clearfix w-100 d-md-none"></hr> */}
            <div className="col-md-2">
              <p className="mt-3 font-weight-bold FooterLinks">Developer</p>
              <ul className="list-unstyled">
                <li>
                  <a
                    href="https://tesseract.in/developers"
                    target="_blank"
                    rel="noreferrer"
                  >
                    JioGlass Developers Program
                  </a>
                </li>
              </ul>
              <p className="mt-4 font-weight-bold FooterLinks">Careers</p>
              <ul className="list-unstyled">
                <li>
                  <a
                    href="https://tesseract.in/careers"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Explore Open Positions
                  </a>
                </li>
              </ul>
              <p className="mt-4 font-weight-bold FooterLinks">Legal</p>
              <ul className="list-unstyled">
                <li>
                  <a
                    href="https://tesseract.in/terms-and-conditions"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms and Conditions
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-md-2 ">
              <p className="mt-3 mb-1 font-weight-bold FooterLinks">Contact</p>
              <ul className="list-unstyled">
                <li>
                  <address>
                    Tesseract Imaging Ltd.
                    <br />
                    Corporate Office: T22, Reliance Corporate Park, Navi
                    <br />
                    Mumbai, India - 400701
                    <br />
                    Mail:{" "}
                    <a href="mailto:developer@tesseract.in">
                      developer@tesseract.in
                    </a>
                  </address>
                </li>
              </ul>
              <br />
              <p className="mt-1 mb-2 font-weight-bold FooterLinks">
                Follow us
              </p>
              <ul className="list-unstyled">
                <li style={{ display: "flex" }}>
                  <span className="mr-1 circle">
                    <a
                      href="https://www.facebook.com/JioGlassDevelopers/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-facebook-square d-flex d-justify-center d-align-center"></i>{" "}
                    </a>
                  </span>
                  <span className="mr-1 circle">
                    <a
                      href="https://www.linkedin.com/company/jioglass-developers/?viewAsMember=true"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-linkedin  d-flex d-justify-center d-align-center"></i>
                    </a>
                  </span>
                  <span className="mr-1 circle">
                    <a
                      href="https://www.reddit.com/user/JioGlassDevelopers"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-reddit-alien  d-flex d-justify-center d-align-center"></i>
                    </a>
                  </span>
                  <span className="mr-1 circle">
                    <a
                      href="https://twitter.com/JioglassDevs"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-twitter  d-flex d-justify-center d-align-center"></i>
                    </a>
                  </span>
                  <span className="mr-1 circle">
                    <a
                      href="https://www.instagram.com/jioglassdevelopers/?hl=en"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {" "}
                      <i className="fab fa-instagram  d-flex d-justify-center d-align-center"></i>
                    </a>
                  </span>
                  <span className="mr-1 circle">
                    <a
                      href="https://www.youtube.com/channel/UCnq2cZZgAfmMREtJp5S6W7w"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {" "}
                      <i className="fab fa-youtube  d-flex d-justify-center d-align-center"></i>
                    </a>
                  </span>
                </li>
              </ul>
            </div>
            {/* <hr className="clearfix w-100 d-md-none"></hr> */}
            <div className="col-md-1"></div>
          </div>
        </div>

        <div className="py-3 m-3 text-center footer-copyright copyright">
          Copyright © 2021 Tesseract Imaging Limited. All Right Reserved.
        </div>
      </footer>
    </div>
  );
};
function ExploreButton() {
  return (
    <button className="btn btn-outline-primary btn-sm exploreBtn">
      Explore
    </button>
  );
}

export default Landingpage;
